module.exports = __webpack_public_path__ + "img/item_bookCover_05.448329ab.jpeg";